import { useApiClient } from '@/composables/useApiClient'

export const state = () => ({
  deliveryInformation: {},
})

export const getters = {
  deliveryInformation: state => state.deliveryInformation,
}

export const actions = {
  setDeliveryInformation({ commit }, info) {
    const addressParameter = info
    commit('SET_DELIVERY_INFO', { ...addressParameter })
  },
  createDeliveryAddress({ commit, dispatch }, parameter) {
    const addressParameter = parameter
    return useApiClient()
      .$post('/delivery-address', addressParameter)
      .then(res => {
        if (res.code === 0) {
          dispatch('setDeliveryInformation', res.data)
        }
      })
      .catch(error => {
        console.error('createDeliveryAddress: error', error)
        return error
      })
  },
  fetchDeliveryAddress({ commit, dispatch }) {
    return useApiClient()
      .$get('/delivery-address')
      .then(res => {
        if (res.code === 0) {
          dispatch('setDeliveryInformation', res.data[0])
        }
      })
      .catch(error => {
        console.error('fetchDeliveryAddress: error', error)
        return error
      })
  },
  updateDeliveryAddress({ commit, dispatch }, { id, parameter }) {
    const addressParameter = parameter
    return useApiClient()
      .$put(`/delivery-address/${id}`, addressParameter)
      .then(res => {
        if (res.code === 0) {
          dispatch('setDeliveryInformation', res.data)
        }
      })
      .catch(error => {
        console.error('fetchDeliveryAddress: error', error)
        return error
      })
  },
  verifyDeliveryAddress({ commit }, { id, bid }) {
    const addressQuery = {
      bid: bid,
    }
    return useApiClient()
      .$get(`/delivery-address/${id}/available`, { params: addressQuery })
      .then(res => {
        if (res.code === 0) {
          return res.data
        }
        return false
      })
      .catch(error => {
        console.error('fetchDeliveryAddress: error', error)
        return error
      })
  },
}

export const mutations = {
  SET_DELIVERY_INFO(state, options) {
    state.deliveryInformation = Object.assign({}, { ...options })
  },
}
